import React, { FC } from "react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Stack } from "@components/base";

interface EntityAssignmentFooter {
  onCancel: () => void;
  onSave: () => void;
}

const EntityAssignmentFooter: FC<EntityAssignmentFooter> = ({
  onCancel,
  onSave,
}) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" justifyContent="space-between">
      <Button variant="outlined" onClick={onCancel}>
        {t("common.cancel")}
      </Button>
      <Button variant="contained" onClick={onSave}>
        {t("common.save")}
      </Button>
    </Stack>
  );
};

export default EntityAssignmentFooter;
